import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-173" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-4xl" data-id="element-174" data-mp="3ksgwy4rr2bbc">
        <div className="text-center" data-id="element-175" data-mp="3fyvxs9ef7bak">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-176" data-mp="3fxuly2pkykrs">
            Avis vérifiés
          </span>
          <h2 className="mt-4 font-display text-[1.85rem] font-black leading-tight tracking-tight text-navy sm:text-[2.6rem]" data-id="element-177" data-mp="36yzeknasv4mw">
            Ce que disent vos{' '}
            <span className="italic text-grape" data-id="element-178" data-mp="31ybgxis2fpjp">collègues</span>
          </h2>
        </div>

        <div className="mx-auto mt-10 grid max-w-3xl gap-5 sm:grid-cols-2" data-id="element-179" data-mp="2x1bk7yh3vz59">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-cream p-6" data-id="element-180" data-mp="2s3t8k0bpf5tk">
              <div className="text-sm text-tangerine" aria-label="5 étoiles sur 5" data-id="element-181" data-mp="qallu5trhlxn">
                <span aria-hidden="true" data-id="element-182" data-mp="h558jwk91lug">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-navy/85" data-id="element-183" data-mp="m5kngsk6j1ej">
                &laquo;{item.quote}&raquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-184" data-mp="c6vexqe6atay">
                <p className="text-xs font-bold text-navy" data-id="element-185" data-mp="c7mwvyeuksir">{item.name}</p>
                <p className="text-xs text-navy/45" data-id="element-186" data-mp="zvwh4vwex87s">{item.role}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}